module.exports = __webpack_public_path__ + "img/bg2.e5781ecd.svg";